
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"23","viewBox":"0 0 30 23","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"30","height":"23","rx":"2","fill":"#122546"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.383 11.427a6.618 6.618 0 113.46 5.817l-2.606.484a.461.461 0 01-.538-.538l.485-2.605a6.587 6.587 0 01-.801-3.159zm5.599-2.707c-.213.18-.367.454-.367.86a.462.462 0 11-.923 0c0-.672.269-1.206.692-1.564.412-.35.947-.514 1.463-.514.516 0 1.05.163 1.462.513.423.36.692.893.692 1.565 0 .471-.12.83-.318 1.126-.166.249-.381.441-.55.593l-.054.048c-.19.17-.332.31-.436.495-.1.176-.18.423-.18.816a.462.462 0 11-.924 0c0-.53.111-.938.3-1.271.184-.325.427-.55.622-.727l.044-.04c.185-.166.313-.28.41-.426.091-.137.163-.316.163-.614 0-.406-.154-.68-.367-.86a1.342 1.342 0 00-.864-.295c-.331 0-.644.106-.865.295zm1.368 6.709a.462.462 0 10-.686-.619l-.006.007a.462.462 0 00.685.618l.007-.006z","fill":"#fff"}})])
          )
        }
      }
    